import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/* export interface Sklop {
  value: string;
  viewValue: string;
} */

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Scenarij {
  value: string;
  viewValue: string;
}

/* export interface TempRazmere {
  value: string;
  viewValue: string;
} */

export interface PadKazalniki {
  value: string;
  viewValue: string;
}

export interface Porecje {
  value: string;
  viewValue: string;
}

export interface SPI {
  value: string;
  viewValue: string;
}

export interface SPEI {
  value: string;
  viewValue: string;
}

export interface Pretok {
  value: string;
  viewValue: string;
}

export interface HpPorecje {
  value: string;
  viewValue: string;
}

export interface HidroPorecje{
  value: string;
  viewValue: string;
} 

export interface VodnoTelo{
  value: string;
  viewValue: string;
} 

export interface PovratnaDoba {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-filter5',
  templateUrl: './filter5.component.html',
  styleUrls: ['./filter5.component.css']
})
export class Filter5Component implements OnInit {

  name:string;

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected4 = undefined;
  selected5 = undefined;
  selected5a = undefined;
  selected6 = undefined;
  selected7 = undefined;
  selected8 = undefined;
  selected9 = undefined;
  selected10 = undefined;
  selected11 = undefined;
  selected11a = undefined;
  selected11b = undefined;
  selected11c = undefined;
  selected12 = undefined;

  public izbira = [
    {value: 1, viewValue: 'Temperatura'},
    {value: 2, viewValue: 'Padavine'},
    {value: 3, viewValue: 'Sneg'},  
    {value: 4, viewValue: 'Sončno obsevanje'},
    {value: 5, viewValue: 'Vodna bilanca'},
    {value: 6, viewValue: 'Hidrološke spremenljivke'},
    {value: 7, viewValue: 'Kazalniki suše'},
    {value: 8, viewValue: 'Raba energije za ogrevanje in hlajenje'},
    {value: 9, viewValue: 'Hidropotencial'}
  ];

  defualtOption = null;
  public spremenljivka = [];
  private agroSpremenljivka = [];
  private agroSprVse = [];
  private postaje = [];
  private energSpr = [];

  /* spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-18', viewValue: 'Povratne dobe letnih visokovodnih konic'}
  ]; */

  /* tempRazmere: TempRazmere[] = [
    {value: 'tmpRaz-23', viewValue: 'Temperatura tal na globini 5 cm'},
    {value: 'tmpRaz-24', viewValue: 'Olistanje drevja'},
    {value: 'tmpRaz-25', viewValue: 'Začetek rastne dobe'},
    {value: 'tmpRaz-26', viewValue: 'Dolžina rastne dobe'},
    {value: 'tmpRaz-27', viewValue: 'Konec rastne dobe'},
    {value: 'tmpRaz-28', viewValue: 'Zadnja spomladanska pozeba'},
    {value: 'tmpRaz-29', viewValue: 'Prva jesenska pozeba'},
    {value: 'tmpRaz-32', viewValue: 'Število dni s spomladansko pozebo'},
    {value: 'tmpRaz-33', viewValue: 'Število dni z jesensko pozebo'},
    {value: 'tmpRaz-30', viewValue: 'Varnostna rezerva pred spomladansko pozebo'},
    {value: 'tmpRaz-31', viewValue: 'Varnostna rezerva pred jesensko pozebo'}
  ]; */
  
  padKazalniki: PadKazalniki[] = [
    {value: 'padKaz-8', viewValue: 'Največja dnevna višina padavin (Rx1day)'},
    {value: 'padKaz-9', viewValue: 'Največja petdnevna višina padavin (Rx5day)'}
  ];

  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ];

  porecje: Porecje[] = [
    //{value: 'porecje-0', viewValue: 'Povodji'},
    {value: 'porecje-1', viewValue: 'Dravinja - Ledava'},
    {value: 'porecje-2', viewValue: 'Ljubljanica - Sotla'},
    {value: 'porecje-3', viewValue: 'Spodnja Drava - Zgornja Soča'},
  ];

  spi: SPI[] = [
    {value: 'spi-0', viewValue: 'Pogostost suše (SPI-6)'},
    {value: 'spi-1', viewValue: 'Trajanje suše (SPI-6)'},
    {value: 'spi-2', viewValue: 'Magnituda suše (SPI-6)'}
  ];

  spei: SPEI[] = [
    {value: 'spei-0', viewValue: 'Pogostost suše (SPEI-6)'},
    {value: 'spei-1', viewValue: 'Trajanje suše (SPEI-6)'},
    {value: 'spei-2', viewValue: 'Magnituda suše (SPEI-6)'}
  ];

  pretok: Pretok[] = [
    {value: 'pretok-0', viewValue: 'Pretok pri 0,5 odstotkih časa'},
    {value: 'pretok-1', viewValue: 'Pretok pri 5 odstotkih časa'},
    {value: 'pretok-2', viewValue: 'Pretok pri 10 odstotkih časa'},
    {value: 'pretok-3', viewValue: 'Pretok pri 25 odstotkih časa'},
    {value: 'pretok-4', viewValue: 'Pretok pri 50 odstotkih časa'},
    {value: 'pretok-5', viewValue: 'Pretok pri 75 odstotkih časa'},
    {value: 'pretok-6', viewValue: 'Pretok pri 90 odstotkih časa'},
    {value: 'pretok-7', viewValue: 'Pretok pri 95 odstotkih časa'}
  ];

  hpPorecje: HpPorecje[] = [
    {value: 'hpPorecje-0', viewValue: 'Podravje'},
    {value: 'hpPorecje-1', viewValue: 'Sava'},
    {value: 'hpPorecje-2', viewValue: 'Pritoki Save brez Savinje, 1. del'},
    {value: 'hpPorecje-3', viewValue: 'Pritoki Save brez Savinje, 2. del'},
    {value: 'hpPorecje-4', viewValue: 'Savinja s pritoki'},
    {value: 'hpPorecje-5', viewValue: 'Posočje in povodje Jadranskega morja'}
  ];

  hidroPorecje: HidroPorecje[] = [
   {value: 'hidroPorecje-0', viewValue: 'Pomurje'},
   {value: 'hidroPorecje-1', viewValue: 'Podravje'},    
   {value: 'hidroPorecje-2', viewValue: 'Sava'},
   {value: 'hidroPorecje-3', viewValue: 'Pritoki Save brez Savinje, 1. del'},
   {value: 'hidroPorecje-4', viewValue: 'Pritoki Save brez Savinje, 2. del'},
   {value: 'hidroPorecje-5', viewValue: 'Savinja s pritoki'},
   {value: 'hidroPorecje-6', viewValue: 'Posočje'},
   {value: 'hidroPorecje-7', viewValue: 'Povodje Jadranskega morja'}
  ]; 

  vodnoTelo: VodnoTelo[] =[
   {value: 'vodnotelo-0', viewValue: 'Jadran'},
   {value: 'vodnotelo-1', viewValue: 'Podravje'},
   {value: 'vodnotelo-2', viewValue: 'Pomurje'},
   {value: 'vodnotelo-3', viewValue: 'Posavje - Alpe'},
   {value: 'vodnotelo-4', viewValue: 'Posavje - aluvij'},
   {value: 'vodnotelo-5', viewValue: 'Posavje - hribovje - kras'}
  ];

  povratnaDoba: PovratnaDoba[] =[
   {value: 'q-0', viewValue: 'Q10'},
   {value: 'q-1', viewValue: 'Q100'},
   {value: 'q-2', viewValue: 'Q500'}
  ]  

  selectDisabled3 = true;
  selectDisabled4 = true;
  selectDisabled5 = true;
  selectDisabled5a = true;
  selectDisabled6 = true;
  selectDisabled7 = true;
  selectDisabled8 = true;
  selectDisabled9 = true;
  selectDisabled10 = true;
  selectDisabled11 = true;
  selectDisabled11a = true;
  selectDisabled11b = true;
  selectDisabled11c = true;
  selectDisabled12 = true;
  hidden3 = false;
  hidden4 = false;
  hidden5 = false;
  hidden5a = false;
  hidden6 = false;
  hidden7 = false;
  hidden8 = false;
  hidden9 = false;
  hidden10 = false;
  hidden11 = false;
  hidden11a = false;
  hidden11b = false;
  hidden11c = false;
  hidden12 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);
    
    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected4 = undefined;
    this.selected5 = undefined;
    this.selected5a = undefined;
    this.selected6 = undefined;
    this.selected7 = undefined;
    this.selected8 = undefined;
    this.selected9 = undefined;
    this.selected10 = undefined;
    this.selected11 = undefined;
    this.selected11a = undefined;
    this.selected11b = undefined;
    this.selected11c = undefined;
    this.selected12 = undefined;

    if (!obj) return;
    
    if (obj.value == 1) {
      this.spremenljivka = [
        {value: 'spr-0', viewValue: 'Povprečna temperatura'},
        {value: 'spr-1', viewValue: 'Najvišja temperatura'},
        {value: 'spr-2', viewValue: 'Najnižja temperatura'},
        {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    
    else if (obj.value == 2) {
      this.spremenljivka = [
        {value: 'spr-5', viewValue: 'Višina padavin'},
        {value: 'spr-8', viewValue: 'Padavinski kazalniki'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 3) {
      this.spremenljivka = [
        { value: 'spr-31', viewValue: 'Število dni s snežno odejo' },
        { value: 'spr-32', viewValue: 'Količina vode v novozapadlem snegu' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }

    else if (obj.value == 4) {
      this.spremenljivka = [
        { value: 'spr-41', viewValue: 'Globalni obsev' },
        { value: 'spr-42', viewValue: 'Trajanje sončnega obsevanja' }
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 5) {
      this.spremenljivka = [
        {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
        {value: 'spr-52', viewValue: 'Skupni odtok'},
        {value: 'spr-53', viewValue: 'Napajanje podzemnih voda'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 6) {
      this.spremenljivka = [
        {value: 'spr-14', viewValue: 'Srednji pretoki'},
        {value: 'spr-15', viewValue: 'Veliki pretoki'},
        {value: 'spr-16', viewValue: 'Mali pretoki'}  
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 7) {
      this.spremenljivka = [
        {value: 'spr-71', viewValue: 'SPI'},
        {value: 'spr-72', viewValue: 'SPEI'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 8) {
      this.spremenljivka = [
        {value: 'spr-81', viewValue: 'Temperaturni primanjkljaj'},
        {value: 'spr-82', viewValue: 'Temperaturni presežek'},
        {value: 'spr-83', viewValue: 'Kurilna sezona'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }
    else if (obj.value == 9) {
      this.spremenljivka = [
        {value: 'spr-91', viewValue: 'Sprememba trajanja pretoka v %'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = true;
      this.selectDisabled11b = true;
      this.selectDisabled11c = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = false;
      this.hidden11b = false;
      this.hidden11c = false;
      this.hidden12 = false;
    }

    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked5a.emit(this.selected5a);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);
    this.eventClicked11.emit(this.selected11);
    this.eventClicked11a.emit(this.selected11a);
    this.eventClicked11b.emit(this.selected11b);
    this.eventClicked11c.emit(this.selected11c);
    this.eventClicked12.emit(this.selected12);
  }

  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-4') {
      this.agroSpremenljivka = [
        {value: 'agro-1', viewValue: 'Temperatura tal'},
        {value: 'agro-2', viewValue: 'Fenološke faze'},
        {value: 'agro-3', viewValue: 'Rastna doba'},
        {value: 'agro-4', viewValue: 'Pozeba'},
      ];
      this.selectDisabled3 = false;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.hidden3 = true;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
    }

    else if (value == 'spr-8') {
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.padKazalniki = this.padKazalniki;
      this.selected3 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
    }

    else if (value == 'spr-14' || value == 'spr-15'|| value == 'spr-16' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled5a = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled11c = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden5a = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden11c = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
    }

    else if (value == 'spr-52' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = false;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = true;
      this.hidden12 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected12 = undefined;
    }

    else if (value == 'spr-53' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled12 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden12 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected12 = undefined;
    }

    else if (value == 'spr-71' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = false;
      this.selectDisabled10 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = true;
      this.hidden10 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }

    else if (value == 'spr-72' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
    }
    else if (value == 'spr-81' ) {
      this.energSpr = [
        {value: 'energSpr-0', viewValue: 'Prag 12 °C'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      this.selected11 = undefined;
    }
    else if (value == 'spr-82' ) {
      this.energSpr = [
        {value: 'energSpr-1', viewValue: 'Prag 18 °C'},
        {value: 'energSpr-2', viewValue: 'Prag 21 °C'},
        {value: 'energSpr-3', viewValue: 'Prag 23 °C'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      this.selected11 = undefined;
    }
    else if (value == 'spr-83' ) {
      this.energSpr = [
        {value: 'energSpr-4', viewValue: 'Trajanje'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      this.selected11 = undefined;
    }
    else if (value == 'spr-91' ) {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled11 = true;
      this.selectDisabled11a = false;
      this.selectDisabled11b = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden11 = false;
      this.hidden11a = true;
      this.hidden11b = true;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      this.selected11 = undefined;
      this.selected11a = undefined;
      this.selected11b = undefined;
    }
    
    else {
      this.selectDisabled3 = true;
      this.selectDisabled4 = true;
      this.selectDisabled5 = true;
      this.selectDisabled6 = true;
      this.selectDisabled7 = true;
      this.selectDisabled8 = true;
      this.selectDisabled9 = true;
      this.selectDisabled10 = true;
      this.selectDisabled12 = true;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
      this.hidden6 = false;
      this.hidden7 = false;
      this.hidden8 = false;
      this.hidden9 = false;
      this.hidden10 = false;
      this.hidden12 = false;
      this.selected3 = undefined;
      this.selected4 = undefined;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
      this.selected8 = undefined;
      this.selected9 = undefined;
      this.selected10 = undefined;
      this.selected12 = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);
    this.eventClicked8.emit(this.selected8);
    this.eventClicked9.emit(this.selected9);
    this.eventClicked10.emit(this.selected10);
    this.eventClicked11.emit(this.selected11);
    this.eventClicked11a.emit(this.selected11a);
    this.eventClicked11b.emit(this.selected11b);

  }

  thirdDropDownChanged(value: any) {
    console.log(value);
    if (value == 'agro-1') {
      this.agroSprVse = [
        {value: 'tmpTal-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)'},
        {value: 'tmpTal-1', viewValue: 'Povprečna temperatura tal na globini 10 cm (april-junij)'},
        {value: 'tmpTal-2', viewValue: 'Povprečna temperatura tal na globini 20 cm (april-junij)'},
        {value: 'tmpTal-3', viewValue: 'Povprečna temperatura tal na globini 30 cm (april-junij)'},
        {value: 'tmpTal-4', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)'},
        {value: 'tmpTal-5', viewValue: 'Povprečna temperatura tal na globini 10 cm (julij-september)'},
        {value: 'tmpTal-6', viewValue: 'Povprečna temperatura tal na globini 20 cm (julij-september)'},
        {value: 'tmpTal-7', viewValue: 'Povprečna temperatura tal na globini 30 cm (julij-september)'}
      ];
      this.selectDisabled5 = true;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden5 = false;
      this.hidden6 = true;
      this.hidden7 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }
    
    else if (value == 'agro-2') {
      this.agroSprVse = [
        {value: 'feno-0', viewValue: 'Olistanje divjega kostanja'},
        {value: 'feno-1', viewValue: 'Olistanje bukve'},
        {value: 'feno-2', viewValue: 'Olistanje lipe'}
      ];
      this.selectDisabled5 = true;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden5 = false;
      this.hidden6 = true;
      this.hidden7 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }

    else if (value == 'agro-3') {
      this.agroSprVse = [
        {value: 'rastDoba-0', viewValue: 'Začetek rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-1', viewValue: 'Začetek rastne dobe za temperaturni prag 10 °C'},
        {value: 'rastDoba-2', viewValue: 'Dolžina rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-3', viewValue: 'Dolžina rastne dobe za temperaturni prag 10 °C'},
        {value: 'rastDoba-4', viewValue: 'Konec rastne dobe za temperaturni prag 5 °C'},
        {value: 'rastDoba-5', viewValue: 'Konec rastne dobe za temperaturni prag 10 °C'}
      ];
      this.selectDisabled5 = true;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden5 = false;
      this.hidden6 = true;
      this.hidden7 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }
    else {
      this.agroSprVse = [
        {value: 'pozeba-0', viewValue: 'Zadnja spomladanska pozeba (0 °C)'},
        {value: 'pozeba-1', viewValue: 'Zadnja spomladanska pozeba (-2 °C)'},
        {value: 'pozeba-2', viewValue: 'Prva jesenska pozeba (0 °C)'},
        {value: 'pozeba-3', viewValue: 'Prva jesenska pozeba (-2 °C)'},
        {value: 'pozeba-4', viewValue: 'Število dni s spomladansko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-5', viewValue: 'Število dni s spomladansko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-6', viewValue: 'Število dni s spomladansko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-7', viewValue: 'Število dni s spomladansko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-8', viewValue: 'Število dni z jesensko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-9', viewValue: 'Število dni z jesensko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-10', viewValue: 'Število dni z jesensko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-11', viewValue: 'Število dni z jesensko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-12', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-13', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-14', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-15', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-16', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-17', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C) za temperaturni prag 10 °C'},
        {value: 'pozeba-18', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C) za temperaturni prag 5 °C'},
        {value: 'pozeba-19', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C) za temperaturni prag 10 °C'}
      ];
      this.selectDisabled5 = true;
      this.selectDisabled6 = false;
      this.selectDisabled7 = true;
      this.hidden5 = false;
      this.hidden6 = true;
      this.hidden7 = false;
      this.selected5 = undefined;
      this.selected6 = undefined;
      this.selected7 = undefined;
    }
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);
    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);
  } 

  fifthDropDownChanged(value: any) {
    console.log(value);
  } 

  fifthaDropDownChanged(value: any) {
    console.log(value);
  } 

  sixthDropDownChanged(value: any) {
    console.log(value);

    if (value == 'tmpTal-0' || value == 'tmpTal-1' || value == 'tmpTal-2' || value == 'tmpTal-3' || value == 'tmpTal-4' || value == 'tmpTal-5' || value == 'tmpTal-6' || value == 'tmpTal-7' ) {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje'},
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Ljubljana'},
        { value: 'post-3', viewValue: 'Novo mesto'},
        { value: 'post-4', viewValue: 'Maribor'},
        { value: 'post-5', viewValue: 'Murska Sobota'},
        { value: 'post-6', viewValue: 'Šmartno pri Slovenj Gradcu'} 
      ];
      this.selectDisabled7 = false;
      this.hidden7 = true;
    }

    else if (value == 'feno-1') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'},
        { value: 'post-8', viewValue: 'Veliki Dolenci'}
      ];
      this.selectDisabled7 = false;
      this.hidden7 = true;
      this.selected7 = undefined;
    }
    else if (value == 'feno-2') {
      this.postaje = [
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'}
      ];
      this.selectDisabled7 = false;
      this.hidden7 = true;
      this.selected7 = undefined;
    }
    else {
      this.postaje = [
        { value: 'post-0', viewValue: 'Bilje'},
        { value: 'post-1', viewValue: 'Celje'},
        { value: 'post-2', viewValue: 'Lesce'},
        { value: 'post-3', viewValue: 'Ljubljana'},
        { value: 'post-4', viewValue: 'Novo mesto'},
        { value: 'post-5', viewValue: 'Portorož'},
        { value: 'post-6', viewValue: 'Slovenske Konjice'},
        { value: 'post-7', viewValue: 'Starše'},
        { value: 'post-8', viewValue: 'Veliki Dolenci'}
      ];
      this.selectDisabled7 = false;
      this.hidden7 = true;
    }

    this.eventClicked6.emit(this.selected6);
    this.eventClicked7.emit(this.selected7);
  } 

  seventhDropDownChanged(value: any) {
    console.log(value);
  } 

  eigthDropDownChanged(value: any) {
    console.log(value);
  } 

  ninthDropDownChanged(value: any) {
    console.log(value);
  } 

  tenthDropDownChanged(value: any) {
    console.log(value);
  } 

  eleventhDropDownChanged(value: any) {
    console.log(value);
  } 

  eleventhaDropDownChanged(value: any) {
    console.log(value);
  } 

  eleventhbDropDownChanged(value: any) {
    console.log(value);
  } 

  eleventhcDropDownChanged(value: any) {
    console.log(value);
  }

  twelveDropDownChanged(value: any) {
    console.log(value);
  } 

  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();
  @Output() eventClicked5a = new EventEmitter<Event>();
  @Output() eventClicked6 = new EventEmitter<Event>();
  @Output() eventClicked7 = new EventEmitter<Event>();
  @Output() eventClicked8 = new EventEmitter<Event>();
  @Output() eventClicked9 = new EventEmitter<Event>();
  @Output() eventClicked10 = new EventEmitter<Event>();
  @Output() eventClicked11 = new EventEmitter<Event>();
  @Output() eventClicked11a = new EventEmitter<Event>();
  @Output() eventClicked11b = new EventEmitter<Event>();
  @Output() eventClicked11c = new EventEmitter<Event>();
  @Output() eventClicked12 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

  onClick5a(selected5a: Event): void {
    this.eventClicked5a.emit(selected5a);
  }

  onClick6(selected6: Event): void {
    this.eventClicked6.emit(selected6);
  }

  onClick7(selected7: Event): void {
    this.eventClicked7.emit(selected7);
  }

  onClick8(selected8: Event): void {
    this.eventClicked8.emit(selected8);
  }
  
  onClick9(selected9: Event): void {
    this.eventClicked9.emit(selected9);
  }

  onClick10(selected10: Event): void {
    this.eventClicked10.emit(selected10);
  }

  onClick11(selected11: Event): void {
    this.eventClicked11.emit(selected11);
  }

  onClick11a(selected11a: Event): void {
    this.eventClicked11a.emit(selected11a);
  }

  onClick11b(selected11b: Event): void {
    this.eventClicked11b.emit(selected11b);
  }

  onClick11c(selected11c: Event): void {
    this.eventClicked11c.emit(selected11c);
  }

  onClick12(selected12: Event): void {
    this.eventClicked12.emit(selected12);
  }

}
